import { env } from '~/config/env';
import { cn } from '~/utils/cn';

const logoSizes = {
  md: 32,
  lg: 40,
  xl: 48,
  '2xl': 64,
} as const;

const fontSizes = {
  md: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
} as const;

const appNames = {
  usmle: 'USMLE Mastery',
  ems: 'EMS Mastery',
  msp: 'MEDSchool Pack',
  mcat: 'MCAT Mastery',
} as const;

export function Logo({
  className,
  size = 'md',
  ...props
}: {
  className?: string;
  size?: keyof typeof logoSizes;
}) {
  return (
    <span className={cn('flex items-center gap-2', className)} {...props}>
      <img
        src={`/img/favicon/${env.VITE_APP}.png`}
        height={logoSizes[size]}
        width={logoSizes[size]}
        alt="Logo"
        className="rounded-lg"
      />
      <span className={cn('font-bold', fontSizes[size])}>
        {appNames[env.VITE_APP]}
      </span>
    </span>
  );
}
